import {ISearchPhraseOptions} from "../../types/ISearchPhraseOptions";
import {ISearchPhraseParams} from "../../types/ISearchPhraseParams";
import {convertToSearchPhraseParts} from "./convert_to_search_phrase_parts";

export function offerMapSearchPhraseBuilder(data: ISearchPhraseParams, options?: ISearchPhraseOptions): string {
    const {offerType} = convertToSearchPhraseParts(data, options);

    return offerType;
}
